// Chart and data visualization components
import { defineAsyncComponent } from 'vue'

export default {
  ChartsAgeDistribution: defineAsyncComponent(
    () => import('../charts/portfolio/age_distribution.vue')
  ),
  ChartsAveragePrices: defineAsyncComponent(
    () => import('../charts/average_prices.vue')
  ),
  ChartsBudgetProfile: defineAsyncComponent(
    () => import('../charts/budget_profile/results.vue')
  ),
  ChartsDashboardVolume: defineAsyncComponent(
    () => import('../charts/dashboard_volume.vue')
  ),
  ChartsElcert: defineAsyncComponent(() => import('../charts/elcert.vue')),
  ChartsMarketOutlookForwards: defineAsyncComponent(
    () => import('../charts/market_outlook/forwards.vue')
  ),
  ChartsMarketPrices: defineAsyncComponent(
    () => import('../charts/market_prices.vue')
  ),
  ChartsMonthlyResults: defineAsyncComponent(
    () => import('../charts/monthly_results.vue')
  ),
  ChartsPortfolioHourlyResult: defineAsyncComponent(
    () => import('../charts/portfolio/hourly_result.vue')
  ),
  ChartsPortfolioPercentResult: defineAsyncComponent(
    () => import('../charts/portfolio/percent_result.vue')
  ),
  ChartsPortfolioProductionRevenue: defineAsyncComponent(
    () => import('../charts/portfolio/production_revenue.vue')
  ),
  ChartsPortfolioScatter: defineAsyncComponent(
    () => import('../charts/portfolio/scatter.vue')
  ),
  ChartsPortfolioSortedResult: defineAsyncComponent(
    () => import('../charts/portfolio/sorted_result.vue')
  ),
  ChartsPowerPlantGeo: defineAsyncComponent(
    () => import('../charts/power_plant/geo.vue')
  ),
  ChartsPowerPlantHistory: defineAsyncComponent(
    () => import('../charts/power_plant/history.vue')
  ),
  ChartsPowerPlantLoad: defineAsyncComponent(
    () => import('../charts/power_plant/load.vue')
  ),
  ChartsPowerPlantMeasureTheorHourly: defineAsyncComponent(
    () => import('../charts/power_plant/measure_theor_hourly.vue')
  ),
  ChartsPowerPlantMeteogram: defineAsyncComponent(
    () => import('../charts/power_plant/meteogram.vue')
  ),
  ChartsPowerPlantMeteogramWind: defineAsyncComponent(
    () => import('../charts/power_plant/meteogram_wind.vue')
  ),
  ChartsPowerPlantPowerCurve: defineAsyncComponent(
    () => import('../charts/power_plant/power_curve.vue')
  ),
  ChartsPowerPlantRunoff: defineAsyncComponent(
    () => import('../charts/power_plant/runoff.vue')
  ),
  ChartsPowerPlantSolarKpiMonthly: defineAsyncComponent(
    () => import('../charts/power_plant/solar_kpi_monthly.vue')
  ),
  ChartsPowerPlantSpider: defineAsyncComponent(
    () => import('../charts/power_plant/spider.vue')
  ),
  ChartsPowerPlantWindKpiMonthly: defineAsyncComponent(
    () => import('../charts/power_plant/wind_kpi_monthly.vue')
  ),
  ChartsPowerPlantsYearlyLoadHour: defineAsyncComponent(
    () => import('../charts/portfolio/power_plants_yearly_load_hour.vue')
  ),
  ChartsReservoirFill: defineAsyncComponent(
    () => import('../charts/reservoir_fill.vue')
  )
}
